module.exports = __webpack_public_path__ + "img/btn.28e857fb.png";